/**
 * Centralized logging utility
 * Only logs to console in development mode
 * In production, logs are suppressed (except errors/warnings)
 */

// Lazy evaluation to avoid TDZ issues on iOS
const isDev = () => import.meta.env.DEV;

export const logger = {
  /**
   * Debug/info logs - only in development
   */
  log: (...args: unknown[]) => {
    if (isDev()) {
      console.log(...args);
    }
  },

  /**
   * Warning logs - always logged
   */
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },

  /**
   * Error logs - always logged
   */
  error: (...args: unknown[]) => {
    console.error(...args);
  },

  /**
   * Debug logs - only in development
   */
  debug: (...args: unknown[]) => {
    if (isDev()) {
      console.debug(...args);
    }
  },

  /**
   * Info logs - only in development
   */
  info: (...args: unknown[]) => {
    if (isDev()) {
      console.info(...args);
    }
  }
};

/**
 * Usage:
 * import { logger } from '@/utils/logger';
 * logger.log('Debug info'); // Only in dev
 * logger.error('Critical error'); // Always logged
 * logger.warn('Warning'); // Always logged
 */
